import { toast } from "react-toastify";
// Reset Date if entered date is greater than max date
export const adjustDateToMax = (inputDate: string, maxDate: string): string => {
  const input = new Date(inputDate);
  const max = new Date(maxDate);

  var finalDate = "";

  if (input > max) {
    finalDate = max.toISOString().split("T")[0];
    toast.error("Date cannot be in Future, Date has been reset", {
      position: "top-right",
      autoClose: 10000,
    });
    return "";
  } else {
    return inputDate;
  }

  // return finalDate;
};

export const adjustDateToMin = (inputDate: string, minDate: string): string => {
  const input = new Date(inputDate);
  const min = new Date(minDate);

  var finalDate = "";

  if (input < min) {
    finalDate = min.toISOString().split("T")[0];
    toast.error("Date cannot be in Past, Date has been reset", {
      position: "top-right",
      autoClose: 10000,
    });
    return "";
  } else {
    return inputDate;
  }

  // return finalDate;
};
